const create = (
  prop: string | string[],
  options?: Partial<{
    delay: number | string;
    duration: number | string;
    easing: string;
  }>,
) => {
  const opts = {
    delay: '0s',
    easing: 'linear',
    duration: duration.standard,
    ...options,
  };
  const props = Array.isArray(prop) ? prop : [prop];
  return props
    .map((prop) => `${prop} ${opts.duration} ${opts.easing} ${opts.delay}`)
    .join(', ');
};

export interface Duration {
  complex: string;
  long: string;
  short: string;
  standard: string;
}

const duration: Duration = {
  complex: '400ms',
  short: '100ms',
  standard: '200ms',
  long: '300ms',
};

export const transitions = { duration, create };
export type Transitions = typeof transitions;
